import { SelectCountryPresenter } from './-components/SelectCountryPresenter';
import { useSelectCountry } from './-hooks/useSelectCountry';
import type { SelectCountryProps } from './-types';

export default function SelectCountry({
  className,
  ...props
}: SelectCountryProps) {
  const hookProps = useSelectCountry(props);
  return <SelectCountryPresenter {...hookProps} className={className} />;
}
